import { Component, OnInit, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';

import { catchError, of, tap } from 'rxjs';
import { Tc, TcPerfilUsuarioEnum, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';

import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { EnumIdsTcEstadoSolicitudEx } from '../../../_exportacion/solicitudes/types/enum';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { BuscadorCpeService } from './buscador-cpe.service';
import { CpeItemResultsViewModel, CpeItemViewModel, FilterSearchingCpeViewModel } from './buscador-cpe.types';
import { SolicitudCpeViewModel } from '../../cpe/datosbasicos/cpe.types';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-buscador-cpe-list',
    templateUrl: './buscador-cpe-list.component.html',
})
export class BuscadorCpeListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultCpe: CpeItemResultsViewModel;
    //listProvincias$: Observable<Tc[]>;
    listComunidad: Tc[];
    listEstado: Tc[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];
    public isCollapsed = false;

    //EnabledCloned: boolean = false;

    habilitarNueva = true;
    visibilitySpinner = false;
    visibilitySpinnerComprobarEphytos = false;
    flagSearchIsComprobarEphytos = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected navMenuService: NavMenuService,
        protected exceptionHandler: ExceptionManager,
        protected configurationService: ConfigurationService,
        private confirmationService: ConfirmationService,
        private buscadorCpeService: BuscadorCpeService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultCpe = new CpeItemResultsViewModel();
    }

    ngOnInit() {
        this.navMenuService.resetSolicitudData();

        this.habilitarNueva = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_CPE).Visible;

        //this.configurationService.getValue("SolicitudEx:EnabledCloned").subscribe(
        //    result => {
        //        this.EnabledCloned = JSON.parse(result);
        //    });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Image', header: '' },
            { field: 'Codigo', header: 'Nº Solicitud' },
            { field: 'NumeroCertificado', header: 'Nº Certificado' },
            { field: 'FechaEnvio', header: 'Fecha' }, // | date:'dd/MM/yyyy'
            { field: 'HoraEnvio', header: 'Hora' }, // | date:'dd/MM/yyyy'
            //{ field: 'UsuarioSolicitante', header: 'Solicitante' },
            { field: 'ComunidadAutonoma', header: 'Comunidad Autónoma' },
            //{ field: 'ProvinciaOperadorCpe', header: 'Provincia Operador' },
            { field: 'NombreOperadorCpe', header: 'Nombre Operador' },
            { field: 'CodigoPostalOperadorCpe', header: 'Código Postal Operador' },
            { field: 'LocalidadOperadorCpe', header: 'Localidad Operador' },
            { field: 'IdEstado', header: 'IdEstado', display: 'none' },
        ];

        this.globalService.getComunidadesAutonomas().subscribe(res => {
            this.listComunidad = res;
        });
        this.globalService.getEstadoSolicitudCpe().subscribe(res => {
            this.listEstado = res;
        });

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.form = this.fb.group({
            Codigo: '',
            NumeroCertificado: '',
            IdEstadoCpe: null,
            //IdProvinciaOperadorCpe: null,
            IdComunidadAutonoma: null,
            NombreOperadorCpe: '',
            UsuarioSolicitante: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
        });

        // let config = this.getConfig();
        //this.paisEspania = parseInt(config.IdPaisEspania);

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack(): void {
        if (
            this.buscadorCpeService.currentFilterCpe.FechaRegistroDesde == null ||
            this.buscadorCpeService.currentFilterCpe.FechaRegistroHasta == null ||
            this.buscadorCpeService.currentFilterCpe.IdEstadoCpe != null ||
            //|| this.buscadorCpeService.currentFilterCpe.IdProvinciaOperadorCpe != null
            this.buscadorCpeService.currentFilterCpe.IdComunidadAutonoma != null ||
            this.buscadorCpeService.currentFilterCpe.Codigo != '' ||
            this.buscadorCpeService.currentFilterCpe.NumeroCertificado != '' ||
            this.buscadorCpeService.currentFilterCpe.NombreOperadorCpe != '' ||
            this.buscadorCpeService.currentFilterCpe.UsuarioSolicitante != '' ||
            this.buscadorCpeService.currentFilterCpe.FechaRegistroDesde!.toString() != this.firstDayMonth.toString() ||
            this.buscadorCpeService.currentFilterCpe.FechaRegistroHasta!.toString() != this.lastDayMonth.toString()
        ) {
            this.form.patchValue({
                IdEstadoCpe: this.buscadorCpeService.currentFilterCpe.IdEstadoCpe,
                //IdProvinciaOperadorCpe: this.buscadorCpeService.currentFilterCpe.IdProvinciaOperadorCpe,
                IdComunidadAutonoma: this.buscadorCpeService.currentFilterCpe.IdComunidadAutonoma,
                Codigo: this.buscadorCpeService.currentFilterCpe.NumeroCertificado,
                NumeroCertificado: this.buscadorCpeService.currentFilterCpe.Codigo,
                NombreOperadorCpe: this.buscadorCpeService.currentFilterCpe.NombreOperadorCpe,
                UsuarioSolicitante: this.buscadorCpeService.currentFilterCpe.UsuarioSolicitante,
                FechaDesde: this.buscadorCpeService.currentFilterCpe.FechaRegistroDesde,
                FechaHasta: this.buscadorCpeService.currentFilterCpe.FechaRegistroHasta,
            });

            this.onSearchButton();
        }
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }
        this.Search(0);
        this.searchingButton = true;
        this.isCollapsed = true;
    }

    CreateModel(): FilterSearchingCpeViewModel {
        let model: FilterSearchingCpeViewModel = new FilterSearchingCpeViewModel();

        model.Codigo = this.form.value.Codigo;
        model.NumeroCertificado = this.form.value.NumeroCertificado;
        model.NombreOperadorCpe = this.form.value.NombreOperadorCpe;
        model.UsuarioSolicitante = this.form.value.UsuarioSolicitante;
        model.IdComunidadAutonoma = this.form.value.IdComunidadAutonoma;
        model.FechaRegistroDesde = this.form.value.FechaDesde;
        model.FechaRegistroHasta = this.form.value.FechaHasta;
        model.IdEstadoCpe = this.form.value.IdEstadoCpe;
        //model.IdProvinciaOperadorCpe = this.form.value.IdProvinciaOperadorCpe;
        model.IdUsuario = this.loggedInUser!.Id;

        //model.EsInspector = this.EsInspector;
        //model.EsCoordinador = this.EsCoordinador;
        model.EsSolicitante = this.isSolicitante;
        model.EsComunidadAutonoma = this.isCA;

        return model;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let model: FilterSearchingCpeViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        //Todo:agaro. 23/01/2020.
        //Establecer la hora de la fecha Hasta si tiene valor a las 23:59:59, que solo lo hace si no se selecciona y no se estaba teniendo
        //en cuenta el propio día de la fecha hasta.
        if (model.FechaRegistroHasta != null) {
            model.FechaRegistroHasta.setHours(23);
            model.FechaRegistroHasta.setMinutes(59);
            model.FechaRegistroHasta.setSeconds(59);
        }

        this.buscadorCpeService
            .postSolicitudPagedByFilter(model)
            .pipe(
                tap(result => {
                    this.resultCpe = result;
                    this.loading = false;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.form?.disable();
                    return of(null);
                }),
            )
            .subscribe();

        this.buscadorCpeService.currentFilterCpe = model;
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            Codigo: '',
            NumeroCertificado: '',
            NombreOperadorCpe: '',
            UsuarioSolicitante: '',
            IdEstadoCpe: null,
            //IdProvinciaOperadorCpe: null,
            IdComunidadAutonoma: null,
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
        });

        this.isCollapsed = false;
        this.searchingButton = false;

        this.resultCpe = new CpeItemResultsViewModel();
    }

    //onSelectComunidad() {

    //    const idCA = this.form.value.IdComunidadAutonoma;

    //    this.listProvincias$ = this.globalService.getProvinciasByComunidad(idCA);

    //    this.form.patchValue({
    //        IdProvinciaOperadorCpe: null,
    //    });

    //}

    onSelectEstado(): void {
        //Si es borrador, limpiamos las fechas
        if (this.form.value.IdEstadoCpe == EnumIdsTcEstadoSolicitudEx.ID_BORRADOR) {
            this.form.patchValue({
                FechaDesde: null,
                FechaHasta: null,
            });
        } else {
            //Todo:agaro. Quitamos que se cambien las fechas si el estado es distinto de borrador, para no alterar los filtros.
            //if (this.form.value.FechaDesde == null || this.form.value.FechaHasta == null) {
            //    this.form.patchValue({
            //        FechaDesde: this.firstDayMonth,
            //        FechaHasta: this.lastDayMonth
            //    });
            //}
        }
    }

    checkDelete(rowData: CpeItemViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ELIMINAR_SOLICITUD_CPE, rowData.IdEstadoCpe).Visible && rowData.EsVisibleEdicion;
    }

    onEdit(item: SolicitudCpeViewModel): void {
        this.router.navigate(['/exportacion/cpe/datosbasicos', item.Id]);
    }

    onDelete(item: SolicitudCpeViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro de eliminar la solicitud?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.buscadorCpeService.deleteSolicitud(item.Id).subscribe(() => {
                    this.addSuccessMessage('Solicitud eliminada correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    onAdd(): void {
        this.navMenuService.currentSolicitudCpe = new SolicitudCpeViewModel();
        this.router.navigate(['/exportacion/cpe/tipossolicitudesCpe']);
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;
        this.buscadorCpeService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }
}
